import { render } from "./BestPage.vue?vue&type=template&id=ce88764c&scoped=true"
import script from "./BestPage.vue?vue&type=script&lang=js"
export * from "./BestPage.vue?vue&type=script&lang=js"

import "./BestPage.vue?vue&type=style&index=0&id=ce88764c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce88764c"]])

export default __exports__